import {
    GET_CATEGORY,
    POST_CATEGORY,
    UPDATE_CATEGORY,
    DELETE_CATEGORY,
    GET_SUBCATEGORY,
    POST_SUBCATEGORY,
    POST_CHILDCATEGORY,
    GET_PRODUCT,
    POST_PRODDUCT,
    UPDATE_PRODUCT,
    DELETE_PRODUCT,
    SEARCH_PRODUCT,
    GET_PRODUCT_BY_ID,
    GET_PRICE_HISTORY_PRODUCT,
    PUT_PRICE_HISTORY_PRODUCT,
    GET_PRODUCT_BY_ARRAY_ID,
    PUT_PRODUCT_EXCEL,
    GET_FULL_PRODUCT_EXCEL,
    GET_LIST_PRODUCT_GSHOP,
    PUT_LIST_PRODUCT_GSHOP,
    DELETE_PRODUCT_GSHOP,
    GET_CATEGORY_GIGA_VN,
    GET_SUB_CATEGORY_GIGA_VN,
    COPY_TO_GIGA_VN,
    CLEAR_DATA,
    GET_TON_KHO_PRICE,
} from "../type";
import { REHYDRATE } from "redux-persist";

const initialState = {
    listCategory: [],
    getProductId: null,
    listSubCategory: [],
    listProduct: [],
    countProduct: 0,
    listSearch: [],
    listProductByArrayId: [],
    listFullProductCategory: [],
    listProductGshop: [],
    countProductGshop: 0,
    listPriceHistoryProduct: [],
    listCategoryGigaVn: [],
    listSubCategoryGigaVn: [],
    tonKhoPrice: {},
};

const product = (state = initialState, action) => {
    switch (action.type) {
        case REHYDRATE: {
            if (!action.payload || !action.payload.product) {
                return state;
            }
            return { ...action.payload.product, isLoading: false };
        }
        case GET_CATEGORY:
            return {
                ...state,
                listCategory: action.data,
            };
        case POST_CATEGORY:
            return {
                ...state,
            };
        case UPDATE_CATEGORY:
            return {
                ...state,
            };
        case DELETE_CATEGORY:
            return {
                ...state,
            };
        case POST_SUBCATEGORY:
            return {
                ...state,
            };
        case POST_CHILDCATEGORY:
            return {
                ...state,
            };
        case GET_SUBCATEGORY:
            return {
                ...state,
                listSubCategory: action.data,
            };
        case GET_CATEGORY_GIGA_VN:
            return {
                ...state,
                listCategoryGigaVn: action.data,
            };
        case GET_SUB_CATEGORY_GIGA_VN:
            return {
                ...state,
                listSubCategoryGigaVn: action.data,
            };
        case COPY_TO_GIGA_VN:
            return {
                ...state,
            };
        case GET_PRODUCT:
            return {
                ...state,
                listProduct: action.data.data,
                countProduct: action.data.count,
            };
        case POST_PRODDUCT:
            return {
                ...state,
            };
        case UPDATE_PRODUCT:
            return {
                ...state,
                listProduct: state.listProduct.map((item) => (item._id === action.data._id ? (item = action.data) : item)),
            };
        case DELETE_PRODUCT:
            return {
                ...state,
                listProduct: state.listProduct.filter((item) => item.slug != action.data),
                countProduct: state.countProduct - 1,
            };
        case SEARCH_PRODUCT:
            return {
                ...state,
                listSearch: action.data,
            };
        case GET_PRODUCT_BY_ID:
            return {
                ...state,
                getProductId: action.data,
            };
        case GET_PRICE_HISTORY_PRODUCT:
            return {
                ...state,
                listPriceHistoryProduct: action.data,
            };
        case PUT_PRICE_HISTORY_PRODUCT:
            return {
                ...state,
                listProduct: state.listProduct.map((item) => (item._id === action.data._id ? (item = action.data) : item)),
            };
        case GET_PRODUCT_BY_ARRAY_ID:
            return {
                ...state,
                listProductByArrayId: action.data,
            };
        case PUT_PRODUCT_EXCEL:
            return {
                ...state,
            };
        case GET_FULL_PRODUCT_EXCEL:
            return {
                ...state,
                listFullProductCategory: action.data,
            };
        case GET_LIST_PRODUCT_GSHOP:
            return {
                ...state,
                listProductGshop: action.data.data,
                countProductGshop: action.data.count,
            };
        case PUT_LIST_PRODUCT_GSHOP:
            return {
                ...state,
            };
        case DELETE_PRODUCT_GSHOP:
            return {
                ...state,
                listProductGshop: state.listProductGshop.filter((item) => item._id != action.data),
                countProductGshop: state.countProductGshop - 1,
            };
        case CLEAR_DATA:
            return {
                ...state,
                listProduct: [],
            };
        case GET_TON_KHO_PRICE:
            return {
                ...state,
                tonKhoPrice: action.data,
            };
        default:
            return state;
    }
};

export default product;
